<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Subline from "../../components/Subline.svelte";
    import type { Project } from "../../components/ProjectPreviews.svelte";
    import { ProjectCateories } from "../../components/ProjectPreviews.svelte";

    import ProjectPreviews from "../../components/ProjectPreviews.svelte";
    import { t } from "../../helpers/translation";

    const loadData = async (): Promise<Project[]> => {
        const data: Project[] = await fetch("/api/projects")
            .then((data) => data.json())
            .then((data) => {
                data.forEach((event) => {
                    if (event.startdate && event.enddate)
                        event.date =
                            new Date(event.startdate).toLocaleDateString() +
                            " - " +
                            new Date(event.enddate).toLocaleDateString();
                    else if (event.startdate)
                        event.date = new Date(
                            event.startdate,
                        ).toLocaleDateString();
                    else if (event.enddate)
                        event.date = new Date(
                            event.enddate,
                        ).toLocaleDateString();
                    else event.date = "";
                });
                data = data.filter(
                    (proj) =>
                        proj.projectcategoryid == ProjectCateories.LEITSTELLE,
                );
                return data;
            });

        return data ? Promise.resolve<Project[]>(data) : Promise.reject(null);
    };

    /* eslint-disable */
</script>

<!-- <LightTheme /> -->

<!-- <Hero headline="Jede Sekunde zählt" small bgimg="https://liveicom.azureedge.net/sinus/img/bg/leitstellen-content-4196.jpg" overlay /> -->
<Hero
    headline={$t("page.leitsysteme.hero.headline")}
    small
    vid="https://liveicom.azureedge.net/sinus/vid/sinus_leitstellensysteme.mp4"
/>

<Container>
    <Headline>
        {@html $t("page.leitsysteme.headline")}
    </Headline>
    <Subline>
        {@html $t("page.leitsysteme.subline")}
    </Subline>

    <!-- <Gap /> -->
    <p>
        {@html $t("page.leitsysteme.p.1")}
    </p>
    <p>
        {@html $t("page.leitsysteme.p.2")}
    </p>
    <p>
        {@html $t("page.leitsysteme.p.3")}
    </p>
    <p>
        {@html $t("page.leitsysteme.p.4")}
    </p>
    <Btn href={$t("file.pdf.mecc.info")} pdf>
        {@html $t("file.pdf.mecc.info.name")}
    </Btn>

    <Gap height="10vw" />

    <ProjectPreviews
        data_callback={loadData}
        url_base="projekte"
        show_empty_message={false}
    />

    <Gap height="4rem" />

    <!-- <center>
        <Btn arrow href="kontakt">
            {@html $t("page.leitsysteme.btn.projectrequest")}
        </Btn>
    </center> -->

    <Gap />
</Container>
